import {
    KatAppLayout
} from "@amzn/katal-react";
import * as React from 'react';
import TopNavigation from "src/app/component/layout/TopNavigation";
import LeftNavigation from "src/app/component/layout/LeftNavigation";
import Footer from "src/app/component/layout/Footer";
import Routes from "src/app/router/Routes";
import {useEffect, useState} from "react";
import {Auth} from "@aws-amplify/auth";
import {Provider} from "mobx-react";
import reviewDecisionStore from "src/app/store/ReviewDecisionStore";
import {isDev} from "src/app/constant/Constants";
import userInfoStore from "src/app/store/UserInfoStore";

const App = () => {
    const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
    useEffect(() => {
        (async () => {
            if(!isDev()) {
                try {
                    const user = await Auth.currentAuthenticatedUser();
                    const userId = user.signInUserSession.idToken.payload.identities[0].userId;
                    userInfoStore.value = userId;
                    console.log(userId);
                    console.log(JSON.stringify(user));
                } catch (err) {
                    await Auth.federatedSignIn({customProvider: 'AmazonFederate'});
                    return;
                }
            }
            setIsUserAuthenticated(true);
        })();
    }, []);

    if (isUserAuthenticated) {
        return (
            <Provider reviewDecisionStore={reviewDecisionStore} userInfoStore={userInfoStore}>
                <KatAppLayout standalone>
                    <TopNavigation data-testid='top-nav'/>
                    <LeftNavigation data-testid='left-nav'/>
                    <Routes data-testid='routes'/>
                    <Footer data-testid='footer'/>
                </KatAppLayout>
            </Provider>
        );
    } else {
        return (
            <div>
                <h1> Unauthenticated User </h1>;
            </div>
        );
    }
};

export default App;